// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import L from 'leaflet';
import directionsHtml from 'text!html/directions.html';
import 'myWorld/uiComponents/dialog';

myw.DirectionsPlugin = myw.Plugin.extend({
    /**
     * @class Plugin for the user to get directions between addresses and/or objects  <br/>
     * Provides a button that when pressed will display a dialog with "from" and "to" fields.
     * "To" will be populated automatically from the current object and "From" can be populated from the current device location
     * @param  {Application} owner  The application
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner, options) {
        myw.Plugin.prototype.initialize.call(this, owner);

        // application event handlers
        this.app.on('internetStatus-changed currentFeature-changed', () => {
            this.trigger('change');
        });

        //Directions Icon function for address search results
        //ENH: replace with a Plugin button
        $(document).on('click', '.details-directions', event => {
            if (!this.app.hasInternetAccess) return;

            const featureUrn = $(event.currentTarget)
                .parent('tr')
                .attr('id')
                .split('-')[1];
            const featureObj = this.app.currentFeatureSet.getFeatureByUrn(featureUrn);
            const featureAddress = featureObj.formattedAddress;

            this.openDirectionsPanel(featureAddress);
        });

        this.render();
    },

    render() {
        this.dialog = new myw.DirectionsDialog(this);
        this.fromInput = this.dialog.$('#directions-from');
        this.toInput = this.dialog.$('#directions-to');
    },

    showDialog() {
        this.dialog.$el.dialog('open');
        this.dialog.$el
            .dialog('widget')
            .find('.directions-go')
            .focus();
    },

    _reverseGeocode(location) {
        const geocoder = this.app.getGeocoder();
        if (!geocoder) return Promise.reject(new Error('no_geocoder')).bind(this);

        return geocoder.reverseGeocode(location).bind(this);
    },

    /**
     * Opens the directions dialog with appropriate from and to fields
     * @param  {string} to
     */
    openDirectionsPanel(to) {
        this.showDialog();

        //Add placeholder
        this.fromInput.attr('placeholder', this.msg('directions_from_placeholder')).val(''); //Also clear its value
        this.toInput.attr('placeholder', this.msg('directions_to_placeholder'));

        //PhoneLayout calls this method directly and doesn't pass any params so we need to calculate the to address
        const featureRep = this.app.getCurrentFeatureRep();

        if (!to && this.app.hasInternetAccess && featureRep) {
            this.reverseGeocode(featureRep.getCenter())
                .then(address => {
                    if (address) this.dialog._setDestAddress(address);
                })
                .catch(error => {});
        } else {
            this.dialog._setDestAddress(to);
        }
    }
});

//get the templates from the html file
const elems = $(directionsHtml),
    dialogHtml = elems.filter('#directions-dialog').html();

myw.DirectionsDialog = myw.Dialog.extend({
    template: _.template(dialogHtml),

    options: {
        modal: true,
        width: 490,
        autoOpen: false,
        position: { my: 'center', at: 'top+204', of: window },
        resizable: false,
        title: '{:directions_title}',
        closeText: '{:close_tooltip}',
        buttons: {
            Go: {
                text: '{:get_directions}',
                class: 'directions-go primary-btn',
                click() {
                    this.goToDirectionsUrl();
                    this.owner.app.recordFunctionalityAccess('core.details_tab.get_directions');
                }
            },
            Close: {
                text: '{:close_btn}',
                class: 'right',
                click() {
                    this.close();
                }
            }
        }
    },

    /**
     * @class Plugin that handles directions functionality<br/>
     * Adds buttons to results list and to the {@link DetailsControl}
     * @param  {Application} owner  The application
     * @constructs
     * @extends {Plugin}
     */
    events: {
        'keypress input': 'handleReturnKeypress',
        'click #directions-current': 'setCurrentLocation',
        'click .reverse-directions-btn': 'reverseDirection',
        'click #directions-go': 'goToDirectionsUrl',
        'click .directions-cancel': 'close'
    },

    /**
     * @class Creates a dialog to show measured distance and area
     * @param  {MeasureToolPlugin}     owner          Measure tool plugin
     * @param  {object}  options
     * @param  {string}                    options.divId  Id to be assigned to the dialog
     * @constructs
     * @extends {Control}
     */
    initialize(owner, options) {
        myw.Dialog.prototype.initialize.call(this, options);
        this.owner = owner;
        this.render();
    },

    render() {
        this.options.contents = this.template();

        myw.Dialog.prototype.render.call(this);
        this.$el
            .dialog('widget')
            .find('.ui-dialog-buttonset')
            .css('float', 'none');

        this.fromInput = this.$('#directions-from');
        this.toInput = this.$('#directions-to');

        this.translate(this.$el);
        this.delegateEvents();
    },

    /**
     * In the event of return key press executed the goToDirectionsUrl method
     */
    handleReturnKeypress(event) {
        if (event.which == 13) {
            this.goToDirectionsUrl();
        }
    },

    /**
     * Open another tab with the url for a google search directions search to the address of the currentFeature
     */
    goToDirectionsUrl() {
        let fromAddress = this._getFromAddress() || '';
        if (fromAddress === this.msg('directions_from')) fromAddress = '';

        window.open(
            `http://maps.google.com/maps?saddr=${encodeURI(fromAddress)}&daddr=${encodeURI(
                this._getDestAddress()
            )}`
        );
    },

    /**
     * Assigns the destination address to the 'To' input field
     * @param  {string} to
     * @private
     */
    _setDestAddress(to) {
        this.toInput.val(to);
    },

    /**
     * Gets the destination address from the 'To' input field
     * @private
     */
    _getDestAddress() {
        return this.toInput.val();
    },

    /**
     * Assigns the origin address to the 'From' input field
     * @param  {string} to
     * @private
     */
    _setFromAddress(to) {
        return this.fromInput.val(to);
    },

    /**
     * Gets the origin's address from the 'From' input field
     * @private
     */
    _getFromAddress() {
        return this.fromInput.val();
    },

    /**
     * Exchanges the values of the from and to input fields
     */
    reverseDirection() {
        const destAddress = this._getDestAddress();
        const fromAddress = this._getFromAddress();
        this._setFromAddress(destAddress);
        this._setDestAddress(fromAddress);
    },

    setCurrentLocation() {
        const app = this.owner.app;

        navigator.geolocation.getCurrentPosition(
            position => {
                //success handler
                if (!position || !position.coords) {
                    return;
                }
                const location = new L.LatLng(position.coords.latitude, position.coords.longitude);
                this.owner
                    ._reverseGeocode(location)
                    .then(theAddress => {
                        if (!theAddress) {
                            app.message(this.msg('problem_locating'));
                            return;
                        }
                        this._setFromAddress(theAddress)
                            .removeClass('watermark')
                            .focus();
                    })
                    .catch(error => {
                        app.message(this.msg(error.message));
                    });
            },
            error => {
                //error handler
                const msgId =
                    error.code === 1 ? 'geolocation_not_authorised' : 'geolocation_generic_error';
                app.message(app.msg(msgId));
            },
            {
                enableHighAccuracy: true,
                maximumAge: 0
            }
        );
    }
});

const DirectionsCurrentFeatureButton = myw.PluginButton.extend({
    id: 'details-directions',
    titleMsg: 'directions_to',
    imgSrc: 'images/actions/directions.svg',
    inactiveImgSrc: 'images/actions/directions-inactive.svg',
    render() {
        this.featureRep = this.app.getCurrentFeatureRep();
        const currentFeature = this.app.currentFeature,
            active =
                this.app.hasInternetAccess &&
                currentFeature &&
                currentFeature.hasGeometry() &&
                this.featureRep;

        this.$el.toggleClass('inactive', !active);

        if (active) this.delegateEvents();
        else this.undelegateEvents();
    },

    action() {
        if (this.app.hasInternetAccess && this.featureRep) {
            this.owner
                ._reverseGeocode(this.featureRep.getCenter())
                .then(address => {
                    if (address) this.owner.openDirectionsPanel(address);
                })
                .catch(error => {
                    const msg = this.owner.msg('reverse_geocode_failed');
                    this.app.message(msg);
                });
        } // else do nothing
    }
});

myw.DirectionsPlugin.prototype.buttons = {
    currentFeature: DirectionsCurrentFeatureButton
};

export default myw.DirectionsPlugin;
